import browserHistory from 'shared/history';
import {deleteEvent, saveEvent} from 'shared/portfolio/actions/college-events';
import {flashMessage, errorMessage} from 'shared/actions/notifications';
import {objectId} from 'shared/utils';
import {closeActivityModalPath} from '../utils';

export const deleteCollegeEvent = (id) => (dispatch) => dispatch(deleteEvent(id, dispatch));

export const saveCollegeEvent = (values) => (dispatch) => {
  // Handle creating a new event.
  if (!values._id) {
    values._id = objectId();
    values.new = true;
  }

  return dispatch(saveEvent(values))
    .then(() => {
      browserHistory.replace(closeActivityModalPath());
      dispatch(flashMessage('Nice! Your achievement has been saved.'));
    })
    .catch(() => {
      dispatch(errorMessage());
    });
};
